import { Currency } from '@fp3/shared'

export const CURRENCY_LABELS: Record<Currency, string> = {
  [Currency.AED]: 'UAE Dirham',
  [Currency.AFN]: 'Afghan Afghani',
  [Currency.ALL]: 'Albanian Lek',
  [Currency.AMD]: 'Armenian Dram',
  [Currency.ANG]: 'Netherlands Antillean Guilder',
  [Currency.AOA]: 'Angolan Kwanza',
  [Currency.ARS]: 'Argentine Peso',
  [Currency.AUD]: 'Australian Dollar',
  [Currency.AWG]: 'Aruban Florin',
  [Currency.AZN]: 'Azerbaijani Manat',
  [Currency.BAM]: 'Bosnia-Herzegovina Convertible Mark',
  [Currency.BBD]: 'Barbadian Dollar',
  [Currency.BDT]: 'Bangladeshi Taka',
  [Currency.BGN]: 'Bulgarian Lev',
  [Currency.BHD]: 'Bahraini Dinar',
  [Currency.BIF]: 'Burundian Franc',
  [Currency.BMD]: 'Bermudan Dollar',
  [Currency.BND]: 'Brunei Dollar',
  [Currency.BOB]: 'Bolivian Boliviano',
  [Currency.BRL]: 'Brazilian Real',
  [Currency.BSD]: 'Bahamian Dollar',
  [Currency.BTC]: 'Bitcoin',
  [Currency.BTN]: 'Bhutanese Ngultrum',
  [Currency.BWP]: 'Botswanan Pula',
  [Currency.BYN]: 'Belarusian Ruble',
  [Currency.BZD]: 'Belize Dollar',
  [Currency.CAD]: 'Canadian Dollar',
  [Currency.CDF]: 'Congolese Franc',
  [Currency.CHF]: 'Swiss Franc',
  [Currency.CLF]: 'Chilean Unit of Account (UF)',
  [Currency.CLP]: 'Chilean Peso',
  [Currency.CNH]: 'Chinese Yuan (Offshore)',
  [Currency.CNY]: 'Chinese Yuan',
  [Currency.COP]: 'Colombian Peso',
  [Currency.CRC]: 'Costa Rican Colón',
  [Currency.CUC]: 'Cuban Convertible Peso',
  [Currency.CUP]: 'Cuban Peso',
  [Currency.CVE]: 'Cape Verdean Escudo',
  [Currency.CZK]: 'Czech Koruna',
  [Currency.DJF]: 'Djiboutian Franc',
  [Currency.DKK]: 'Danish Krone',
  [Currency.DOP]: 'Dominican Peso',
  [Currency.DZD]: 'Algerian Dinar',
  [Currency.EGP]: 'Egyptian Pound',
  [Currency.ERN]: 'Eritrean Nakfa',
  [Currency.ETB]: 'Ethiopian Birr',
  [Currency.EUR]: 'Euro',
  [Currency.FJD]: 'Fijian Dollar',
  [Currency.FKP]: 'Falkland Islands Pound',
  [Currency.GBP]: 'British Pound',
  [Currency.GEL]: 'Georgian Lari',
  [Currency.GGP]: 'Guernsey Pound',
  [Currency.GHS]: 'Ghanaian Cedi',
  [Currency.GIP]: 'Gibraltar Pound',
  [Currency.GMD]: 'Gambian Dalasi',
  [Currency.GNF]: 'Guinean Franc',
  [Currency.GTQ]: 'Guatemalan Quetzal',
  [Currency.GYD]: 'Guyanaese Dollar',
  [Currency.HKD]: 'Hong Kong Dollar',
  [Currency.HNL]: 'Honduran Lempira',
  [Currency.HRK]: 'Croatian Kuna',
  [Currency.HTG]: 'Haitian Gourde',
  [Currency.HUF]: 'Hungarian Forint',
  [Currency.IDR]: 'Indonesian Rupiah',
  [Currency.ILS]: 'Israeli New Shekel',
  [Currency.IMP]: 'Isle of Man Pound',
  [Currency.INR]: 'Indian Rupee',
  [Currency.IQD]: 'Iraqi Dinar',
  [Currency.IRR]: 'Iranian Rial',
  [Currency.ISK]: 'Icelandic Króna',
  [Currency.JEP]: 'Jersey Pound',
  [Currency.JMD]: 'Jamaican Dollar',
  [Currency.JOD]: 'Jordanian Dinar',
  [Currency.JPY]: 'Japanese Yen',
  [Currency.KES]: 'Kenyan Shilling',
  [Currency.KGS]: 'Kyrgystani Som',
  [Currency.KHR]: 'Cambodian Riel',
  [Currency.KMF]: 'Comorian Franc',
  [Currency.KPW]: 'North Korean Won',
  [Currency.KRW]: 'South Korean Won',
  [Currency.KWD]: 'Kuwaiti Dinar',
  [Currency.KYD]: 'Cayman Islands Dollar',
  [Currency.KZT]: 'Kazakhstani Tenge',
  [Currency.LAK]: 'Laotian Kip',
  [Currency.LBP]: 'Lebanese Pound',
  [Currency.LKR]: 'Sri Lankan Rupee',
  [Currency.LRD]: 'Liberian Dollar',
  [Currency.LSL]: 'Lesotho Loti',
  [Currency.LYD]: 'Libyan Dinar',
  [Currency.MAD]: 'Moroccan Dirham',
  [Currency.MDL]: 'Moldovan Leu',
  [Currency.MGA]: 'Malagasy Ariary',
  [Currency.MKD]: 'Macedonian Denar',
  [Currency.MMK]: 'Myanmar Kyat',
  [Currency.MNT]: 'Mongolian Tögrög',
  [Currency.MOP]: 'Macanese Pataca',
  [Currency.MRU]: 'Mauritanian Ouguiya',
  [Currency.MUR]: 'Mauritian Rupee',
  [Currency.MVR]: 'Maldivian Rufiyaa',
  [Currency.MWK]: 'Malawian Kwacha',
  [Currency.MXN]: 'Mexican Peso',
  [Currency.MYR]: 'Malaysian Ringgit',
  [Currency.MZN]: 'Mozambican Metical',
  [Currency.NAD]: 'Namibian Dollar',
  [Currency.NGN]: 'Nigerian Naira',
  [Currency.NIO]: 'Nicaraguan Córdoba',
  [Currency.NOK]: 'Norwegian Krone',
  [Currency.NPR]: 'Nepalese Rupee',
  [Currency.NZD]: 'New Zealand Dollar',
  [Currency.OMR]: 'Omani Rial',
  [Currency.PAB]: 'Panamanian Balboa',
  [Currency.PEN]: 'Peruvian Sol',
  [Currency.PGK]: 'Papua New Guinean Kina',
  [Currency.PHP]: 'Philippine Peso',
  [Currency.PKR]: 'Pakistani Rupee',
  [Currency.PLN]: 'Polish Złoty',
  [Currency.PYG]: 'Paraguayan Guaraní',
  [Currency.QAR]: 'Qatari Riyal',
  [Currency.RON]: 'Romanian Leu',
  [Currency.RSD]: 'Serbian Dinar',
  [Currency.RUB]: 'Russian Ruble',
  [Currency.RWF]: 'Rwandan Franc',
  [Currency.SAR]: 'Saudi Riyal',
  [Currency.SBD]: 'Solomon Islands Dollar',
  [Currency.SCR]: 'Seychellois Rupee',
  [Currency.SDG]: 'Sudanese Pound',
  [Currency.SEK]: 'Swedish Krona',
  [Currency.SGD]: 'Singapore Dollar',
  [Currency.SHP]: 'Saint Helena Pound',
  [Currency.SLL]: 'Sierra Leonean Leone',
  [Currency.SOS]: 'Somali Shilling',
  [Currency.SRD]: 'Surinamese Dollar',
  [Currency.STN]: 'São Tomé & Príncipe Dobra',
  [Currency.SVC]: 'Salvadoran Colón',
  [Currency.SYP]: 'Syrian Pound',
  [Currency.SZL]: 'Swazi Lilangeni',
  [Currency.THB]: 'Thai Baht',
  [Currency.TJS]: 'Tajikistani Somoni',
  [Currency.TMT]: 'Turkmenistani Manat',
  [Currency.TND]: 'Tunisian Dinar',
  [Currency.TOP]: 'Tongan Paʻanga',
  [Currency.TRY]: 'Turkish Lira',
  [Currency.TTD]: 'Trinidad & Tobago Dollar',
  [Currency.TWD]: 'New Taiwan Dollar',
  [Currency.TZS]: 'Tanzanian Shilling',
  [Currency.UAH]: 'Ukrainian Hryvnia',
  [Currency.UGX]: 'Ugandan Shilling',
  [Currency.USD]: 'US Dollar',
  [Currency.UYU]: 'Uruguayan Peso',
  [Currency.UZS]: 'Uzbekistani Som',
  [Currency.VES]: 'Venezuelan Bolívar',
  [Currency.VND]: 'Vietnamese Đồng',
  [Currency.VUV]: 'Vanuatu Vatu',
  [Currency.WST]: 'Samoan Tālā',
  [Currency.XAF]: 'Central African CFA Franc',
  [Currency.XAG]: 'Silver (troy ounce)',
  [Currency.XAU]: 'Gold (troy ounce)',
  [Currency.XCD]: 'East Caribbean Dollar',
  [Currency.XDR]: 'IMF Special Drawing Rights',
  [Currency.XOF]: 'West African CFA Franc',
  [Currency.XPD]: 'Palladium (troy ounce)',
  [Currency.XPF]: 'CFP Franc',
  [Currency.XPT]: 'Platinum (troy ounce)',
  [Currency.YER]: 'Yemeni Rial',
  [Currency.ZAR]: 'South African Rand',
  [Currency.ZMW]: 'Zambian Kwacha',
  [Currency.ZWL]: 'Zimbabwean Dollar',
}
